
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-6'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>시스템 관리 - 메세지 로그</p>
          <div class="Admin_PageHeader_btn">
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_message_log_all
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  mounted () {
    get_message_log_all().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        pagination: 'local',
        paginationSize: 100,
        paginationButtonCount: 5,
        columns: [
          {title: 'ID', field: 'message_log_ID', headerSort: false},
          {title: '수신자', field: 'message_log_receiver', headerSort: false},
          {title: '메세지', field: 'message_log_message', headerSort: false},
          {title: '발송일자', field: 'message_log_registe', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminMessageLogManagement.vue